// В.2.f-1: Матрица Клонирования (liv_matritsa_klonirovaniya, legendary, 0/2/8).
// Приказ при выставлении: воскрешает до 3 случайных юнитов из СВОЕГО сброса.
//
// Поведение:
//   - Кандидаты: только живые юниты (type==='unit') в стопке сброса игрока.
//   - До 3 случайных через rng.shuffle/pick.
//   - Если в сбросе нет юнитов — Приказ сгорает с записью в лог.
//   - Если на поле своей стороны < 3 свободных слотов — воскрешает столько,
//     сколько помещается. Не воскрешённые остаются в сбросе.
//   - resurrectUnit на случайные свободные слоты (по правилам resurrect.js).
//   - Молчание Матрицы блокирует Приказ (стандартная проверка).
//
// Без picker'а — эффект автоматический.
//
// ВАЖНО: в xlsx ability_text у этой карты помечен как 'deathrattle' (это
// текст автора каталога, расхождение с диздоком). По спецификации шага В.2.f-1
// эффект — Приказ. Регистрируем оба поля в warn-unimplemented, чтобы
// загрузчик не ругался.

import { resurrectUnit } from './resurrect.js';
import { registerImplementedAbility } from './warn-unimplemented.js';

export const CARD_ID = 'liv_matritsa_klonirovaniya';
const LABEL = 'Матрица Клонирования';
const MAX_RESURRECT = 3;

registerImplementedAbility(CARD_ID, 'order', 'deathrattle');

export function matritsaKlonirovaniaOrder(state, ownerIdx, matritsa /*, opts */) {
  if (!matritsa || !matritsa.isAlive()) return;
  if (matritsa.current?.silenced) return;
  const me = state.players?.[ownerIdx];
  if (!me) return;
  // Кандидаты в сбросе.
  const candidates = me.discard.filter(c => c?.type === 'unit');
  if (candidates.length === 0) {
    state.log?.add(`🔁 ${LABEL} [${me.name}]: в сбросе нет юнитов — Приказ сгорает`);
    return;
  }
  // Перемешиваем копию массива и берём до 3.
  const pool = pickRandomN(candidates, MAX_RESURRECT, state.rng);
  let resurrected = 0;
  for (const dead of pool) {
    if (!me.hasFreeSlot()) break;
    const ok = resurrectUnit(state, dead, ownerIdx, null);
    if (ok) resurrected += 1;
  }
  state.log?.add(`🔁 ${LABEL} [${me.name}]: воскрешено ${resurrected} юнит${pluralRu(resurrected)}`);
}

function pickRandomN(arr, n, rng) {
  const copy = [...arr];
  for (let i = 0; i < n && i < copy.length; i++) {
    const j = i + rng.int(copy.length - i);
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy.slice(0, Math.min(n, copy.length));
}

function pluralRu(n) {
  const n10 = n % 10, n100 = n % 100;
  if (n10 === 1 && n100 !== 11) return 'а';
  if ([2, 3, 4].includes(n10) && ![12, 13, 14].includes(n100)) return 'ов';
  return 'ов';
}
